const getAllScrollBlocks = () => {
  let arrResult = []
  const scrollElemList = document.querySelectorAll('.scroll-js')

  for (let i = 1; i <= scrollElemList.length; i++) {
    arrResult.push(document.querySelector(`.scroll-js${i}`))
  }

  return arrResult
}

const fullScroll = getAllScrollBlocks()

const syncScroll= (array) => {
  let forcedScroll = false;

  array.forEach((item, index )=> {
    if (array.length > index + 1) {
      console.log(item)
      item.addEventListener('scroll', () => {
        performScroll(item, array[index + 1], array)
      })
    } else {
      item.addEventListener('scroll', () => {
        performScroll(item, array[0], array)
      })
    }
  })

  const performScroll = (scrolled, toScroll, array) => {
    if (forcedScroll) return (forcedScroll = false)

    let percent = (scrolled.scrollLeft /
      (scrolled.scrollWidth - scrolled.clientWidth)) * 100
    setScrollTopFromPercent(toScroll, percent, array)
  }

  const setScrollTopFromPercent = (el, percent, array) => {
    let scrollLeftPos = (percent / 100) *
      (el.scrollWidth - el.clientWidth)
    forcedScroll = true

    $.each(array ,(index, item) => {
      if (el !== item) {
        item.scrollLeft = Math.round(scrollLeftPos)
      }
    })
  }
}

if ($('.scroll-js1').length > 0) {
  syncScroll(fullScroll);
}
